import _ from 'lodash';

export const getFieldSelector = (mapping, key) => {
  const fields = _.get(mapping, 'fields') || [];
  const field = fields.find(item => item.name === key);

  return field;
}

export const getContentForFieldSelector = (mapping, key) => {
  const field = getFieldSelector(mapping, key);

  if (!field) {
    return null;
  }

  return _.get(field, `content`);
}